import { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarIcons from "./SidebarIcons";
import dayjs from "dayjs";
import { useParams, useNavigate, generatePath } from "react-router-dom";
import { useSelector } from "react-redux";
import { GET_DOOR_INSPECTION_AUDIT_TRAIL } from "../api/apiPath";
import http from "../api/server";
import Toaster from "./common/Toaster";
import dashlogo from "../assets/img/dashbarlogo.png";

import StatusPill from "./common/StatusPill";

export default function AuditRail() {
  const {
    inspectionMasterId,
    inspectionRefnumber,
    propertyMasterId,
    doorRefNumber,
    clientNameParam,
  } = useParams();
  const [hideSidebar, setHideSidebar] = useState(false);
  const { userObj } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const [openIndex, setOpenIndex] = useState(null);
  const [summary, setSummary] = useState({});
  const [inspectionRefNo, setInspectionRefNo] = useState("");

  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleBack = () => {
    navigate(
      generatePath(
        "/client/:clientNameParam/property-view-details/:propertyMasterId/:inspectionRefnumber",
        {
          clientNameParam,
          propertyMasterId,
          inspectionRefnumber,
        },
      ),
    );
  };

  useEffect(() => {
    const fetchBookingHistory = async () => {
      try {
        setLoading(true);

        const { data } = await http.get(GET_DOOR_INSPECTION_AUDIT_TRAIL, {
          params: {
            DoorReferenceNumber: doorRefNumber,
            InspectionReferenceNumber: inspectionRefnumber,
          },
        });
        const firstEvent = data?.events?.[0];

        if (firstEvent?.inspectionReferenceNumber) {
          setInspectionRefNo(firstEvent.inspectionReferenceNumber);
        }

        const getIcon = (eventType) => {
          switch (eventType) {
            case "Door Inspected":
              return "fa-solid fa-circle-check";
            case "Request for Change":
              return "fa-solid fa-circle-check";

            case "Approved":
              return "fa-solid fa-circle-check";

            default:
              return "fa-solid fa-circle-check";
          }
        };
        const summaryData = data?.summaries?.[0] || {};
        setSummary(summaryData);

        const formattedSteps = data?.events?.map((item) => ({
          icon: getIcon(item.eventType),
          title: item.eventType,
          date: item.eventDate,
          boxText: item.performedBy
            ? `${item.eventType} by - ${item.performedBy}`
            : item.eventType,
          highlight: false,
        }));

        setSteps(formattedSteps || []);
      } catch (err) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: err?.message,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBookingHistory();
  }, [userObj?.clientId, inspectionMasterId]);

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-2">
            <div className="dashboard_header">
              <div>
                <h2 className="mb-0">Door Inspection History</h2>
                <p className="header-description mb-0">
                  Track the complete timeline of your site inspection
                </p>
                {/* <div className="download-container">
                  {showLoader ? (
                    <div className="loader"></div>
                  ) : }
                    <button
                      className="btn btn-dark fw-semibold"
                      // onClick={() => {
                      //   handleDownloadClick(propertyMasterId);
                      // }}
                      title="Download Report"
                    >
                      <i className="fa fa-download me-2"></i> Download Report
                    </button>
                  )}
                </div> */}
              </div>
            </div>

            <div
              className="card mt-4 p-3 rounded-4 mb-4 orange-box d-flex gap-3 flex-row align-items-center justify-content-between"
              style={{ height: "9.5rem" }}
            >
              <div className="card-body">
                <div className="d-flex align-items-center justify-content-evenly text-center py-4">
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      1
                    </h1>
                    <p className="fw-semibold mb-0">Total Doors</p>
                  </div>
                  <div className="col-6 col-sm-4 col-lg-2 mb-1">
                    <img src={dashlogo} alt="Inspector" height="100" />
                  </div>
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalCriticalIssues}
                    </h1>
                    <p className="fw-semibold mb-0">Total Critical Issues</p>
                  </div>
                  <div>
                    <h1 className="mb-0" style={{ fontSize: "4rem" }}>
                      {summary?.totalNonCompliantIssues}
                    </h1>
                    <p className="fw-semibold mb-0">
                      Total Non-Compliant Issues
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <h5 className="justifyStart fw-semibold mb-0 ">
                      {summary?.propertyName}
                    </h5>

                    <p className="justifyCenter mb-0 mt-1">
                      {/* <StatusPill status="Completed" /> */}
                      <StatusPill status={summary?.doorStatus} />
                    </p>
                  </div>

                  <p className="justifyStart text mb-0 mt-1">
                    <b>Location : </b>
                    {summary?.doorLocation}
                  </p>

                  <div className="d-flex justify-content-between align-items-center w-100 mt-4 mb-4 text-black">
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ color: "#525254" }}>
                        Inspection Reference No :
                      </span>
                      <span>{inspectionRefNo || "-"}</span>
                    </div>

                    <p className="d-flex align-items-center mb-0 gap-2">
                      <span style={{ color: "#525254" }}>
                        Inspection Managed By :
                      </span>
                      <span>{summary?.inspectionManagedBy}</span>
                    </p>
                  </div>
                </div>
                <div></div>
              </div>
            </div>

            <div className="resident-card mb-3">
              <div className=" flex-sm-row align-items-center ">
                <div className="col-12 col-sm-4 col-lg-4 justify-content-sm-start w-100">
                  <p className="text-start">
                    <b>Inspection Timeline</b>
                  </p>
                  <div className="timeline">
                    {loading ? (
                      <p>Loading timeline...</p>
                    ) : steps.length > 0 ? (
                      steps.map((step, index) => (
                        <div className="timeline-item-row" key={index}>
                          {/* LEFT SIDE: icon + title + date */}
                          <div className="timeline-left">
                            <div className="timeline-icon">
                              {step.icon === "dot" ? (
                                <div className="dot"></div>
                              ) : (
                                // <i className={step.icon}></i>
                                <div className="exact-check-icon">
                                  <i className="fa-solid fa-check"></i>
                                </div>
                              )}
                            </div>
                          </div>

                          <div
                            className="inspection-box text-start p-3"
                            style={{
                              backgroundColor: "#F9F9F9",
                              border: "1px solid #E5E5E5",
                            }}
                            onClick={() =>
                              setOpenIndex(openIndex === index ? null : index)
                            }
                          >
                            <div className="timeline-info">
                              <div
                                className={`inspection-title-after ${
                                  step.highlight
                                    ? "text-danger fw-semibold"
                                    : ""
                                }`}
                              >
                                <div className="d-flex align-items-center">
                                  <span>{step.boxText}</span>
                                  {/* <i
                                    className={`bi ${
                                      openIndex === index
                                        ? "bi-chevron-up"
                                        : "bi-chevron-down"
                                    } ms-auto`}
                                  ></i> */}
                                </div>
                              </div>

                              <div className="inspection-date text">
                                {/* {step.date} */}
                                {step.date
                                  ? dayjs(step.date, [
                                      "DD-MMM-YYYY hh:mm A",
                                      "YYYY-MM-DDTHH:mm:ss",
                                    ])
                                      .format("MMM-DD-YYYY hh:mm A")
                                      .toUpperCase()
                                  : ""}
                              </div>

                              {/* {openIndex === index && (
                                <div className="step-details mt-2">
                                  <p className="text">
                                    Property was successfully added to the
                                    system. All initial information was verified
                                    and confirmed.
                                  </p>
                                </div>
                              )} */}
                            </div>

                            {/* <span className="dropdown-arrow">▼</span> */}
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No booking history found.</p>
                    )}
                  </div>
                  <div className="card-body action_btns d-flex justify-content-end gap-3 pb-3 px-3 flex-wrap flex-sm-nowrap">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={() => {
                        handleBack();
                      }}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer />
        </div>
      )}
    </>
  );
}
